import { RouteObject } from 'react-router-dom';
import SignOutComponent from './sign-out/sign-out-component';
import LoginRedirect from './login-redirect/LoginRedirect';

const AUTH_ROUTES: RouteObject[] = [
    {
        path: "",
        element: <LoginRedirect />,
    },
    {
        path: "logout",
        element: <SignOutComponent />,
    },
];

export default AUTH_ROUTES;
